import axios from 'axios';
import {DestinationTrend, ScanSeries, ShortSummary, Trend} from "@/scripts/types/analytics";

interface requestParams {
    from?: string,
    to?: string,
    codeIdentifier?: string
}

export const getDeviceTrends = async (
    from: string,
    to: string,
    codeIdentifier?: string
) => {
    const params: requestParams = {
        from: from,
        to: to,
        codeIdentifier: codeIdentifier
    }

    return (await axios.get("/api/analytics/deviceTrends", {params})).data as Trend[]
};

export const getScansForEachHours = async (
    from: string,
    to: string,
    codeIdentifier?: string
) => {
    const params: requestParams = {
        from: from,
        to: to,
        codeIdentifier: codeIdentifier
    }

    return (await axios.get("/api/analytics/scansCountForEachHour", {params})).data as Trend[]
};

export const getDestinationTrends = async (
    from: string,
    to: string,
    codeIdentifier?: string
) => {
    const params: requestParams = {
        from: from,
        to: to,
        codeIdentifier: codeIdentifier
    }

    return (await axios.get("/api/analytics/destinationTrends", {params})).data as DestinationTrend[]
};

export const getCitiesTrends = async (
    from: string,
    to: string,
    codeIdentifier?: string
) => {
    const params: requestParams = {
        from: from,
        to: to,
        codeIdentifier: codeIdentifier
    }

    return (await axios.get("/api/analytics/citiesTrends", {params})).data as Trend[]
};

export const getCodeTrends = async (
    from: string,
    to: string,
    codeIdentifier?: string
) => {
    const params: requestParams = {
        from: from,
        to: to,
        codeIdentifier: codeIdentifier
    }

    return (await axios.get("/api/analytics/trends", {params})).data as Trend[]
};

export const getScans = async (
    from: string,
    to: string,
    codeIdentifier?: string
) => {
    const params: requestParams = {
        from: from,
        to: to,
        codeIdentifier: codeIdentifier
    }

    return (await axios.get("/api/analytics/scans", {params})).data as ScanSeries[]
};

export const getUniqScans = async (
    from: string,
    to: string,
    codeIdentifier?: string
) => {
    const params: requestParams = {
        from: from,
        to: to,
        codeIdentifier: codeIdentifier
    }

    return (await axios.get("/api/analytics/uniqScans", {params})).data as ScanSeries[]
};

export const getShortSummary = async (codeIdentifier?: string) => {
    const params: requestParams = {
        codeIdentifier: codeIdentifier
    }

    return (await axios.get("/api/analytics/summary", {params})).data as ShortSummary
};
